var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVipCheckMark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.497,
    height: 21.497,
    viewBox: "1168.751 748.503 21.497 21.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16221"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "cancel"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1179.5 748.503c5.936 0 10.748 4.812 10.748 10.748 0 5.937-4.812 10.749-10.748 10.749-5.937 0-10.749-4.812-10.749-10.749 0-5.936 4.812-10.748 10.749-10.748Z",
    fill: "#11b700",
    fillRule: "evenodd",
    "data-name": "Mask"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1175.27 759.82 4.051 3.26 3.344-8.473",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 2,
    stroke: "#fff",
    fill: "transparent",
    "data-name": "Path 1293"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10.4a10.5 10.5 0 1 1 0 .1z",
    "data-name": "Mask",
    transform: "translate(.412 .412)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVipCheckMark);
export default __webpack_public_path__ + "static/media/vipCheckMark.56cb82f6b0cc1aec3851d43b00b11cb4.svg";
export { ForwardRef as ReactComponent };